import React from "react";
// import { Redirect } from "react-router";
import { Navigate } from 'react-router-dom';

export default function RedirectComponent() {
  return <Navigate to="/" />;
}
